import { SurveysParticipantViewsPage } from "@/pages/talent/surveys/SurveysParticipantViewsPage.tsx";

export const SurveyHistoryPage = () => {
  return <SurveysParticipantViewsPage mode="history" />;
};
